import 'react-responsive-carousel/lib/styles/carousel.min.css';
import React, { isValidElement, ReactElement } from 'react';
import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel';

import { DEFAULT_CONFIG } from './Carousel.constants';
import { TCarouselProps } from './Carousel.types';
import styles from './Carousel.module.scss';

function Carousel({ children, ...restProps }: TCarouselProps): ReactElement {
  const items = (Array.isArray(children)
    ? (children as ReactElement[])
    : [children]
  ).filter((child) => isValidElement(child));

  return (
    <ResponsiveCarousel
      className={styles.wrapper}
      {...DEFAULT_CONFIG}
      {...restProps}
      showIndicators={items.length > 1}>
      {items}
    </ResponsiveCarousel>
  );
}

export { Carousel };
